import {
  Component,
  OnDestroy,
  ElementRef,
  HostListener,
  ChangeDetectorRef,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { formatDateByPattern, getLocalTimeZone } from '../../../helpers/date.helper';

// import { loadStripe } from '@stripe/stripe-js';
import { error } from 'node:console';
import { CommonmodelService } from '../../../services/commonmodel/commonmodel.service';
import { faStarHalfStroke } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
declare var Razorpay: any;
declare var window: any;
import posthog from 'posthog-js';
@Component({
  selector: 'app-bookappointment',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FontAwesomeModule],
  templateUrl: './bookappointment.component.html',
  styleUrl: './bookappointment.component.css',
})
export class BookappointmentComponent implements OnChanges, OnInit {
  faStarHalfStroke = faStarHalfStroke;
  @Input() inputFromParent: any;
  @Input() inputFromParent1: any;
  originalPakageAmount: any;
  aftereAchangPakageTosingleSeeAmount: any;
  changeStepOfpackage: boolean = false;
  step_1: boolean = true;
  step_2: boolean = false;
  datahideonclose: boolean = true;
  stripe: any;
  card: any;
  isExpanded: boolean = false;
  clientSecret: string = ''; // Your clientSecret here
  addressElement: any;
  getAddressVlaue: any;
  name123 = '';
  city = '';
  line2 = '';
  line1 = '';
  state = '';
  displayStyle10 = 'none';
  paymentHandler: any = null;
  displayStyle: any;
  coupon_applied: any;
  removeCouponCodeForByUser: any;
  toggle = true;
  status = 'Enable';
  name: any;
  MinFromDate: any;
  MinToDate: any;
  showSpelisation: any;
  hcpId: any;
  displayStyle1 = 'none';
  displayStyle2 = 'none';
  displayStyle3 = 'none';
  displayStyle4 = 'none';
  BlockStartTime: any;
  BlockEndTime: any;
  duration_of_difficulties: any;
  describeDifficulties: any;
  rate_difficulties: any;
  drDetailsDataFor: any;
  drAvaibilityDataFor: any;
  drBusy: any;
  isFirstAppointment: any;
  feeAmount: any;
  IsfirstAppointmentcheckedValue: boolean = false;
  IsflowupAppointmentcheckedValue: boolean = false;
  slideShow: any = 1;
  sessionTypeShow: any = 2;
  sessionTypeShow1: any = 2;
  sessionBookTab: any = 1;
  schedulTabTypeShow: any;
  availabeTabTypeShow: any;
  drImageBaseUrl = environment.baseUrl + '/MediaUploads/UserUpload/';
  profileImage: any;
  totalRecord: any;
  loaderShow: boolean = false;
  userDetailsData: any;
  sessionId: any;
  HCPTypeId: any;
  currentTimeZone: any;
  PatientId: any;
  patientGender: any;
  patientOccupation: any;
  drListData: any;
  getHcpScheduleData: any;
  currentDateForSchedule: any;
  booktbnEnable: boolean = true;
  hcpReviewByPatient: any;
  specialisation: any;
  timeZone: any;
  cuponData: any;
  CouponId: any;
  couponList: any;
  displayStyle8 = 'none';
  countryCode: any = '+91';
  RqestQueryFormData: any;
  submitted = false;
  couponCodeText: String = '';
  applyText: String = 'Apply';
  couponCodeDesiabled: boolean = false;
  couponCodeMessage: String = '';
  hcpLastname: any;
  hcpFirstName: any;

  customArr2 = [];  
  countryCodeName:any

   otherDuration: string = '';

  predefinedOptions: string[] = [
    '1-3 Days',
    '3-6 Days',
    '1-2 week',
    '3-4 week',
    '4-5 week',
    '3-4 Months',
    '4-5 Months'
  ];


  customArr1 = [
    {
      Date: 1727721000,
      data: ['05:00 AM to 11:00 PM'],
    },
    {
      Date: 1727807400,
      data: ['05:00 AM to 11:00 PM'],
    },
    {
      Date: 1727893800,
      data: ['05:00 AM to 11:00 PM'],
    },
    {
      Date: 1727980200,
      data: ['05:00 AM to 11:00 PM'],
    },
    {
      Date: 1728066600,
      data: ['05:00 AM to 11:00 PM'],
    },
    {
      Date: 1728153000,
      data: [],
    },
    {
      Date: 1728239400,
      data: [],
    },
  ];
  dificultyRate: any = [
    {
      id: '1',
      src: 'img/dr_img/emoji1.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji1.png',
    },
    {
      id: '2',
      src: 'img/dr_img/emoji2.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji2.png',
    },
    {
      id: '3',
      src: 'img/dr_img/emoji3.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji3.png',
    },
    {
      id: '4',
      src: 'img/dr_img/emoji4.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji4.png',
    },
    {
      id: '5',
      src: 'img/dr_img/emoji5.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji5.png',
    },
    {
      id: '6',
      src: 'img/dr_img/emoji6.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji6.png',
    },
    {
      id: '7',
      src: 'img/dr_img/emoji7.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji7.png',
    },
    {
      id: '8',
      src: 'img/dr_img/emoji8.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji8.png',
    },
    {
      id: '9',
      src: 'img/dr_img/emoji9.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji9.png',
    },
    {
      id: '10',
      src: 'img/dr_img/emoji10.png',
      acive: false,
      activesrc: 'img/dr_img/colouremoji10.png',
    },
  ];

  minDate: any;
  selectSingleSession: boolean = true;
  selectPakageSession: boolean = false;
  selectPakageTypeTabShow: any = 1;
  packageTypeData: any;
  async ngOnInit() {
     const apiValue = '';  // Change this to test

    this.setDurationFromAPI(apiValue);
       this.timeZone = getLocalTimeZone();
    console.log(this.timeZone);
    this.invokeStripe();
    this.intervalId = setInterval(() => this.animatePlaceholder(), 1000);
    console.log(this.customArr1);
    this.MinFromDate = formatDateByPattern(new Date());
    this.MinToDate = this.MinFromDate;

    var dtToday = new Date();
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    var tempmonth = '';
    var temday = '';
    if (month < 10) {
      tempmonth = '0' + month;
    } else {
      tempmonth = month.toString();
    }
    if (day < 10) {
      temday = '0' + day;
    } else {
      temday = day.toString();
    }
    // ;
    this.minDate = year + '-' + tempmonth + '-' + temday;
    this.RqestQueryFormData = this.fb.group({
      fullName: ['', Validators.required],
      phone: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        ]),
      ],
      date: ['', Validators.required],
      time: ['', Validators.required],
    });
  }
  get f() {
    return this.RqestQueryFormData.controls;
  }

  assentListTab: any = [
    { name: 'About Me', id: 1 },
    { name: 'Specialty ', id: 2 },
    { name: 'Education ', id: 3 },
    { name: 'Reviews', id: 4 },
  ];

  sessionArrayBook: any = [
    { id: 1, name: 'Single Session' },
    { id: 2, name: 'Package' },
  ];
setDurationFromAPI(value: string) {

    if (!value) return;

    if (this.predefinedOptions.includes(value)) {
      this.duration_of_difficulties = value;
    } else {
      this.duration_of_difficulties = 'Others';
      this.otherDuration = value;
    }
  }

  // 🔹 Reset custom field if not Others
  onDurationChange(value: string) {
    if (value !== 'Others') {
      this.otherDuration = '';
    }
  }
  sessionTypeArray: any = [
    // {
    //   id: 1,
    //   name: 'Audio',
    //   icon: 'img/dr_img/phone-call.svg',
    //   class: 'fa fa-phone',
    // },
    {
      id: 2,
      name: 'Video',
      icon: 'img/dr_img/video-camera.svg',
      class: 'fa fa-video-camera',
    },
    // {
    //   id: 3,
    //   name: 'Chat',
    //   icon: 'img/dr_img/chat.svg',
    //   class: 'fa fa-comments',
    // },
  ];
  selectPakageType: any = [
    { id: 1, name: 'Individual' },
    { id: 2, name: 'Couple' },
  ];
  placeholderTexts = [
    'Psychiatrist',
    'Clinical Psychologist',
    'Counselling Psychologist',
    'Primary Care',
  ];
  currentPlaceholder = this.placeholderTexts[0];
  private index = 0;
  private intervalId: any;
  animatePlaceholder() {
    this.currentPlaceholder =
      'Select a' + ' ' + this.placeholderTexts[this.index];
    this.index = (this.index + 1) % this.placeholderTexts.length;
  }
  selectedPackageTypeSssion: any;
  package_code: any = '';
  no_of_calls: any;
  percentage_off: any;
  package_purchase_date: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private dashboard: AuthService,
    private route: Router,
    private http: HttpClient,
    private elem: ElementRef,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private commonmodel: CommonmodelService,

  ) {
    let actualTumeZone = this.dashboard.getTimeZone();
    if (actualTumeZone == 'Asia/Calcutta') {
      this.timeZone = 'Asia/Kolkata';
    } else {
      this.timeZone = actualTumeZone;
    }
    console.log('this.timeZone', this.timeZone);
    if (typeof window !== 'undefined') {
      this.userDetailsData = sessionStorage.getItem('userDetailsData');
      this.userDetailsData = JSON.parse(this.userDetailsData);
      console.log(this.userDetailsData);
      this.countryCode = sessionStorage.getItem('countryCode');
      console.log('this.countryCode', this.countryCode);
      this.sessionId = this.userDetailsData.SessionId;
      this.HCPTypeId = this.userDetailsData.HCPTypeId;
      this.PatientId = this.userDetailsData.PatientId;
      this.patientGender = this.userDetailsData.gender;
      this.patientOccupation = this.userDetailsData.occupation;
      this.profileImage = this.userDetailsData.Image;
    }

    this.loadScript();
    if (typeof window !== 'undefined') {
      this.userDetailsData = sessionStorage.getItem('userDetailsData');
      this.userDetailsData = JSON.parse(this.userDetailsData);
      console.log(this.userDetailsData);
      this.sessionId = this.userDetailsData.SessionId;
      this.HCPTypeId = this.userDetailsData.HCPTypeId;
      console.log('this.HCPTypeId', this.HCPTypeId);
      this.PatientId = this.userDetailsData.PatientId;
      this.patientGender = this.userDetailsData.gender;
      this.patientOccupation = this.userDetailsData.occupation;
      this.profileImage = this.userDetailsData.Image;
    }

    // this.loadScript();
  }
  onInit() {
    console.log('Book Appointment Component Initialized');
  }
  oldDateTimeZone: any;
  bookSession(data: any, pagesection: any) {
    let actualTumeZone = this.dashboard.getTimeZone();
    if (actualTumeZone == 'Asia/Calcutta') {
      this.oldDateTimeZone = 'Asia/Kolkata';
    } else {
      this.oldDateTimeZone = actualTumeZone;
    }
    
    this.countryCode = '';
    this.couponList = '';
    this.removeApplyBtn = true;
    this.couponCodeDesiabled = true;
    this.applyText = 'Apply';
    this.initailizeRatingIcon();
    this.countryCode = sessionStorage.getItem('countryCode');
    let countryCodeNameDR = sessionStorage.getItem('countryCode');
    console.log('countryCodeNameDR', countryCodeNameDR);
    if(countryCodeNameDR == '+91'||countryCodeNameDR == '91'){
      this.countryCodeName = 'India';
    }
    if(countryCodeNameDR == '+1'||countryCodeNameDR == '1'){
      this.countryCodeName = 'united states';
    }
    if(countryCodeNameDR == '+44'||countryCodeNameDR == '44'){
      this.countryCodeName = 'united kingdom';
    }
    
    this.IsfirstAppointmentcheckedValue = false;
    this.IsflowupAppointmentcheckedValue = false;
    this.slideShow = pagesection;
    this.removeCouponCodeForByUser = '';

    this.getHcpReview(data.id);
    this.loaderShow = true;
    this.displayStyle1 = 'block';
    let winDiv = this.document.getElementById('bodyId');
    winDiv?.classList.add('b');
    // this.displayStyle2 = 'block';
    this.HCPTypeId = data.HCPTypeId;
    this.hcpFirstName = data.FirstName;
    this.hcpLastname = data.LastName;
    console.log('this.HCPTypeId', this.HCPTypeId);
    console.log(data);
    this.isFirstAppointment = data.isFirstAppointment;

    if (this.isFirstAppointment == 1) {
    
      if (this.accessCodedata) {
        // this.feeAmount = data.first_appointment_fee - (data.follow_up_fee / 100) * this.accessCodedata;
        let fixedAmount = data.first_appointment_fee - (data.first_appointment_fee * this.accessCodedata) / 100;
      
     let calculatedAmount =
  data.first_appointment_fee -
  (data.first_appointment_fee * this.accessCodedata) / 100;

let decimalPart = calculatedAmount % 1; // get decimal part
console.log('Decimal Part:', decimalPart);
if (decimalPart <= 0.5) {
  // this.feeAmount = Math.floor(calculatedAmount);
  this.feeAmount = Math.ceil(calculatedAmount);
  console.log('Rounded Down:', this.feeAmount);
 
} else {
  this.feeAmount = Math.ceil(calculatedAmount);
  console.log('Rounded Up:', this.feeAmount);

}

        
      
        // alert("hi"+this.isFirstAppointment)
        this.IsfirstAppointmentcheckedValue = true;
      } else {
         let fixedAmount = data.first_appointment_fee - (data.first_appointment_fee * this.accessCodedata) / 100;
     
     let calculatedAmount =
  data.first_appointment_fee -
  (data.first_appointment_fee * this.accessCodedata) / 100;

let decimalPart = calculatedAmount % 1; // get decimal part

if (decimalPart <= 0.5) {
  this.feeAmount = Math.floor(calculatedAmount);
  console.log('Rounded Down:', this.feeAmount);
  
} else {
  this.feeAmount = Math.ceil(calculatedAmount);
  console.log('Rounded Up:', this.feeAmount);
 
}
        this.feeAmount = data.first_appointment_fee;
        this.aftereAchangPakageTosingleSeeAmount = data.first_appointment_fee;
        
        this.removeCouponCodeForByUser = data.follow_up_fee;
        this.IsfirstAppointmentcheckedValue = true;
      }
    } else {
      if (this.accessCodedata) {
         let fixedAmount = data.follow_up_fee - (data.follow_up_fee * this.accessCodedata) / 100;
       
     let calculatedAmount =
  data.follow_up_fee -
  (data.follow_up_fee * this.accessCodedata) / 100;

let decimalPart = calculatedAmount % 1; // get decimal part

if (decimalPart <= 0.5) {
  this.feeAmount = Math.floor(calculatedAmount);
  console.log('Rounded Down:', this.feeAmount);
  
} else {
  this.feeAmount = Math.ceil(calculatedAmount);
  console.log('Rounded Up:', this.feeAmount);
  
}
        // this.feeAmount = data.follow_up_fee - (data.follow_up_fee / 100) * this.accessCodedata;
        this.feeAmount =Math.ceil(data.follow_up_fee - (data.follow_up_fee * this.accessCodedata) / 100);
        
        this.IsflowupAppointmentcheckedValue = true;
      } else {
         let fixedAmount = data.follow_up_fee - (data.follow_up_fee * this.accessCodedata) / 100;
       
     let calculatedAmount =
  data.follow_up_fee -
  (data.follow_up_fee * this.accessCodedata) / 100;

let decimalPart = calculatedAmount % 1; // get decimal part

if (decimalPart <= 0.5) {
  this.feeAmount = Math.floor(calculatedAmount);
  console.log('Rounded Down:', this.feeAmount);
 
} else {
  this.feeAmount = Math.ceil(calculatedAmount);
  console.log('Rounded Up:', this.feeAmount);
  
}
        this.feeAmount =Math.ceil(data.follow_up_fee);
        
        this.aftereAchangPakageTosingleSeeAmount = data.follow_up_fee;
        this.removeCouponCodeForByUser = data.first_appointment_fee;
        this.IsflowupAppointmentcheckedValue = true;
      }
    }
    console.log('this.isFirstAppointment', this.isFirstAppointment);
    console.log(this.getHcpScheduleData);
    var today = new Date();
    console.log(today);
    var year = today.getFullYear();
    var mes = today.getMonth() + 1;
    var dia = today.getDate();
    var currentDate = mes + '-' + dia + '-' + year;
    this.currentDateForSchedule = currentDate;
    console.log(currentDate);
    var todayDateTime = new Date().toLocaleString('en-US', {
      timeZone: this.timeZone,
    });
    this.hcpId = data.id;
    console.log(todayDateTime);
    let getHcpInformationPayload = {
      SessionId: this.sessionId,
      PatientId: this.PatientId,
      patientGender: this.patientGender,
      hcpId: data.id,
      patientOccupation: this.patientOccupation,
      country: this.countryCodeName,
      //  country: 'United States',
      // country:'united kingdom',
    };
    console.log("test",getHcpInformationPayload)
    let getHcpschedulePayload = {
      hcp_id: data.id,
      SessionId: this.sessionId,
      Date: currentDate,
      Timezone: this.oldDateTimeZone,
    };
    console.log(getHcpschedulePayload);

    this.dashboard.CheckHCPSchedule(getHcpschedulePayload).subscribe(
      (res: any) => {
        console.log('.....................', res.response);
        this.getHcpScheduleData = res.response;
        console.log(this.getHcpScheduleData);
        this.getHcpScheduleData.forEach((e: any, i: any) => {
          let newDate = new Date(e.Date);
          let sss = Date.parse(e.Date) / 1000;
          let dd = Math.floor(sss);
          console.log('sssssssssssssss', sss);
        });
        this.cdr.detectChanges();
        console.log('customArr1', this.customArr1);
        console.log('duplicate array', this.getHcpScheduleData);
        console.log(
          'GetscheduleDataaWeekffdhafsdhfagshd',
          this.getHcpScheduleData
        );
        this.gGetAvailableBlockOfAppointmentCheck(this.getHcpScheduleData[0],'Time Slot Selection', {} as Event);
        this.loaderShow = false;
      },
      (error) => {
        console.log(error);
        this.loaderShow = false;
      }
    );
    this.dashboard.GetHcpInformation(getHcpInformationPayload).subscribe(
      (res: any) => {
        console.log(res);
        let sp = res.data.specialisation;
        let dsp = sp.split(',');
        console.log(dsp);
        this.specialisation = dsp;
        this.drDetailsDataFor = res.data;

        console.log('ssssssss', this.drDetailsDataFor);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  getAllApplicableCouponCode() {
    let obj = {
      HcpId: this.hcpId,
      PatientId: this.PatientId,
    };
    console.log(obj);
    this.dashboard.getAllApplicableCouponCode(obj).subscribe((res: any) => {
      console.log('res.............', res);
      this.cuponData = res.data;
      console.log('res.............', this.cuponData);
    });
  }
  removeApplyBtn: boolean = true;
  appliedCoupon: string | null = null;
  applyCouponCode(a: any, t: any,pagesection: any, event: any) {
    const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    console.log('hihhhh', a, t);
    console.log(a);
    // ;
    this.appliedCoupon = a.coupon_name;
    if (t == '0') {
      // ;
      this.cuponData.forEach((item: any) => {
        if (a == item.coupon_name) {
          a = item.id;
          this.couponCodeMessage = '';
          this.applyText = 'Applied';
          this.couponCodeDesiabled = true;
          this.couponCodeText = item.coupon_name;
          this.removeApplyBtn = false;
          // ;
          let obj = {
            HcpId: this.hcpId,
            PatientId: this.PatientId,
            CouponId: a,
          };
          console.log(obj);
          this.dashboard.getDiscountedCouponPrice(obj).subscribe((res: any) => {
            console.log(res);
            this.couponList = res.data;
            console.log(this.couponList);
            this.feeAmount = this.couponList.amount_to_be_paid;
            console.log(
              'this.feeAmount afetr aply coupon code',
              this.feeAmount
            );
          });
        } else {
          this.couponCodeMessage = 'Coupon code is not valid';
          this.applyText = 'Apply';
          this.couponCodeDesiabled = false;
        }
      });
    }

    if (t == 1) {
      console.log(a);
      this.coupon_applied = a.coupon_name + ',' + a.percentage_off;
      console.log(this.coupon_applied);
      this.applyText = 'Applied';
      this.removeApplyBtn = false;
      this.couponCodeText = a.coupon_name;
      this.couponCodeDesiabled = true;
      a = a.id;
      this.couponCodeMessage = '';
      let obj = {
        HcpId: this.hcpId,
        PatientId: this.PatientId,
        CouponId: a,
      };
      console.log(obj);
      this.dashboard.getDiscountedCouponPrice(obj).subscribe((res: any) => {
        console.log(res);
        this.couponList = res.data;
        console.log(this.couponList);
        this.feeAmount = this.couponList.amount_to_be_paid;
        console.log('this.feeAmount afetr aply coupon code', this.feeAmount);
      });
    }
  }
  removedCouponCode(pagesection: any, event: any) {
    const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    this.couponList = '';
    this.couponCodeText = '';
    this.applyText = 'Apply';
    this.appliedCoupon = null;
    this.couponCodeDesiabled = false;
    this.feeAmount = this.removeCouponCodeForByUser;
    this.couponCodeDesiabled = false;
    this.couponCodeMessage = '';
    this.removeApplyBtn = true;
  }
  gGetAvailableBlockOfAppointmentCheck(c: any,pagesection: any, event: any) {
      const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: 'Time Slot',
  page: 'dashboard',
  section: pagesection
});
    console.log('cccgfdgasfdgfdgfasgdfg', c);
    this.schedulTabTypeShow = c.Date;
    console.log('hfchasf', this.schedulTabTypeShow);
    if (c.data != '') {
      let Slotetime = c.data[0];
      let s = Slotetime.split('to');
      console.log(s);
      let preferred_from_time = s[0];
      let preferred_to_time = s[1];

      console.log(preferred_from_time);
      console.log(preferred_to_time);

      let obj = {
        SessionId: this.sessionId,
        HCP_Id: this.hcpId,
        Device_Timezone: this.timeZone,
        preferred_from_time: preferred_from_time / 1000,
        preferred_to_time: preferred_to_time / 1000,
      };
      console.log('hgchgzchghcgashgc', obj);
      this.dashboard.gGetAvailableBlockOfAppointmentCheck(obj).subscribe(
        (res: any) => {
          console.log(res);
          this.drAvaibilityDataFor = res.data;
          console.log('drt available', this.drAvaibilityDataFor);
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      this.drAvaibilityDataFor = '';
    }
  }
  bookSessionWithDr(pagesection: any, event: any) {
    const buttonText =
        (event.target as HTMLElement)?.innerText?.trim() || 'unknown';
    
      posthog.capture('Button Clicked', {
      button_name: buttonText,
      page: 'dashboard',
      section: pagesection
    });
    this.commonmodel.subject.next('modal-md');
    // this.displayStyle1 = 'none';
    // this.displayStyle2 = 'block';
    let divId = document.getElementById('id2');
    divId?.classList.add('add');
    this.getAllApplicableCouponCode();
    this.duration_of_difficulties = '';
    this.describeDifficulties = '';
    this.rate_difficulties = 1;
    this.datahideonclose = false;
    this.step_1 = false;
    this.step_2 = true;
    console.log(this.package_code);
    // ;
    if (this.package_code != '') {
      this.couponCodeDesiabled = true;
    } else {
      this.couponCodeDesiabled = false;
    }
  }
  viewMoreSpecilisation(a: any) {
    this.displayStyle4 = 'block';
    this.showSpelisation = a;
  }
  closeSpecilisaion() {
    this.displayStyle4 = 'none';
  }
  disableDate() {
    return false;
  }
  availableTab(s: any,pagesection: any, event: any) {
      const buttonText =
        (event.target as HTMLElement)?.innerText?.trim() || 'unknown';
    
      posthog.capture('Button Clicked', {
      button_name: buttonText,
      page: 'dashboard',
      section: pagesection
    });
    this.availabeTabTypeShow = s.BlockTitle;
    console.log('..............', s);
    this.booktbnEnable = false;
    this.BlockStartTime = s.BlockStartTime;
    this.BlockEndTime = s.BlockEndTime;
  }
  getDateCalender(d: any) {
      let actualTumeZone = this.dashboard.getTimeZone();
      console.log("hvcshcvhasvchash actualTumeZone",actualTumeZone);
    if (actualTumeZone == 'Asia/Calcutta') {
      this.timeZone = 'Asia/Kolkata';
    } else {
      this.timeZone = actualTumeZone;
    }
    console.log(d.value);
    let tt = new Date(d.value);
    this.currentDateForSchedule = tt;
    console.log(this.currentDateForSchedule);
    var today = this.currentDateForSchedule;
    console.log(today);
    var year = today.getFullYear();
    var mes = today.getMonth() + 1;
    var dia = today.getDate();
    var currentDate = mes + '-' + dia + '-' + year;
    this.currentDateForSchedule = currentDate;
    console.log(currentDate);
    let getHcpschedulePayload = {
      hcp_id: this.hcpId,
      SessionId: this.sessionId,
      Date: currentDate,
      Timezone: this.timeZone,
    };

    console.log(getHcpschedulePayload);
    this.dashboard.CheckHCPSchedule(getHcpschedulePayload).subscribe(
      (res: any) => {
        console.log(res);
        this.getHcpScheduleData = res.response;
        console.log(this.getHcpScheduleData[0].Date);
        this.gGetAvailableBlockOfAppointmentCheck(this.getHcpScheduleData[0],'Time Slot Selection', {} as Event);
        // console.log(
        //   '.....getHcpScheduleData.........',

        //   this.drAvaibilityDataFor

        // );

        this.loaderShow = false;
      },
      (error) => {
        console.log(error);
        this.loaderShow = false;
      }
    );
  }
  applyFilter(name: any) {
    console.log(name.value);
    this.drListData = this.drListData.filter((iten: any) => {
      if (iten.FirstName.includes(name.value)) {
        return iten;
      }
    });
  }
  cancelAppointment() {
    this.displayStyle2 = 'none';
    let divId = document.getElementById('id2');
    divId?.classList.remove('add');
  }
  getHcpReview(id: any) {
    console.log(id);
    let obj = {
      HCPId: id,
      SessionId: this.sessionId,
    };
    this.dashboard.getHcpReview(obj).subscribe((res: any) => {
      console.log('gfdghsafdgasfdg reviw', res);
      this.hcpReviewByPatient = res.data;
    });
  }
  placeAppointmentReques(pagesection: any, event: any) {
    const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    this.countryCode = sessionStorage.getItem('countryCode');
    let obj = {
       "patient_id": this.PatientId,
       "start_time": this.BlockStartTime,
       "end_time": this.BlockEndTime,
      }
    console.log(obj);
    this.http.post(environment.baseUrl + '/mobileappointment/check-existing-appointment', obj).subscribe((res: any) => {
      console.log('AddToFavorite', res);
      if(res.success){
         console.log(this.countryCode);
            if (this.countryCode == '+91'|| this.countryCode == '+44'||this.countryCode == '91'|| this.countryCode == '44') {
              this.payWithRazor();
            } else {
              if(this.feeAmount<=0){
                 this.bookAppointmentUsedByAccesscodewithzeroPayment()
              }
              else{
                 this.payStripeInt();
              }
             
            }
      }

    },(err:any)=>{
      console.log('error', err.error);
      alert(err.error.message)
     
       
          
    });

   
  }
  OnClick_Header(a: any,pagesection: any, event: any) {
      const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    console.log(this.assentListTab);
    this.slideShow = a;
    console.log('array' + a);
  }
  sessionTypeTab(a: any, pagesection: any, event: any) {
       const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    this.sessionTypeShow1 = a.id;
    console.log('array' + a);
  }
  selectPakageTypeTab(a: any, pagesection: any, event: any) {
    if(a==1){
      this.selectPakageTypeTabShow = 1;
     

  posthog.capture('Button Clicked', {
  button_name: 'Individual',
  page: 'dashboard',
  section: pagesection
});
    }
    if(a==2){
        posthog.capture('Button Clicked', {
  button_name: 'Couple',
  page: 'dashboard',
  section: pagesection
});
    }

    this.selectPakageTypeTabShow = a;

    console.log('array' + a);
    let payload = {
      package_type: this.selectPakageTypeTabShow,
      HcpId: this.hcpId,
    };
    this.dashboard.getPackageDetailsforHcpId(payload).subscribe({
      next: (res: any) => {
        // Handle success response
        console.log(res);
        this.packageTypeData = res.data;
        console.log(this.packageTypeData);
      },
      error: (err) => {
        // Handle error response
      },
    });
  }

  selectPackageData(data: any,pagesection: any, event: any) {
        const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    // ;
    this.selectPakageSession = false;
    this.selectSingleSession = true;
    this.changeStepOfpackage = true;
    console.log(data);
    /*  this.sessionBookTab=1; */
    this.selectedPackageTypeSssion = data.package_type;
    this.applyText='Applied';
    this.feeAmount = data.discounted_amount;
    this.package_code = data.package_code;
    this.percentage_off = data.percentage_off;
    this.no_of_calls = data.no_of_calls;
    this.originalPakageAmount = data.original_amount;

    console.log(
      this.selectedPackageTypeSssion,
      this.percentage_off,
      this.package_code
    );
  }
  backStepForpakace() {
    this.changeStepOfpackage = false;
    this.selectPakageSession = true;
    this.selectSingleSession = false;
  }

  sessionBookTabEvent(a: any,pagesection: any, event: any) {
      const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

 
    this.sessionBookTab = a.id;
    console.log('array' + a);
    this.selectSingleSession = true;
    this.selectPakageSession = false;
    console.log(this.sessionBookTab);
    if (this.sessionBookTab == 1) {
       posthog.capture('Button Clicked', {
  button_name: 'Single Session',
  page: 'dashboard',
  section: pagesection
});
      // alert(this.sessionBookTab)
      // this.feeAmount=this.aftereAchangPakageTosingleSeeAmount;
      this.selectSingleSession = true;
      this.selectPakageSession = false;
      this.selectedPackageTypeSssion = '';
      // this.selectedPackageTypeSssion=false;
    }
    if (this.sessionBookTab == 2) {
       posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
      // alert(this.sessionBookTab)
      this.selectSingleSession = false;
      this.selectPakageSession = true;
      this.selectPakageTypeTab(1, pagesection, event);
    }
  }

  thankYouModelClose() {
    this.displayStyle1 = 'none';
  }
  public loadScript() {
    let body = <HTMLDivElement>this.document.body;
    let script = this.document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
  payWithRazor() {
    console.log('this.HCPTypeId', this.HCPTypeId);
    let actualCurrency = '';
     if(this.countryCode == '+91'|| this.countryCode == '91'){
      actualCurrency = 'INR';
     }
     else{
      actualCurrency = 'GBP';
     }
    let options: any = {
      // key: 'rzp_test_JrtXNXEBZZ9gzM',
      // key: 'rzp_live_FtsfuQdSlTicnU',
      key: environment.keyRazerPay,
      // rzp_live_FtsfuQdSlTicnU,
      amount: Math.ceil(this.feeAmount), // amount should be in paise format to display Rs 1255 without decimal point
      // currency: 'INR',
       currency:actualCurrency,
      // name: form.value.name,
      description: '',
      image:
        'https://www.mannkaa.com/assets/img/header/mannkaa_logo_header.svg', // company logo or product image
      order_id: '', // order_id created by you in backend
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },
      notes: {
        // include notes if any
      },
      theme: {
        color: '#092C44',
      },
      // redirect: true,
      // callback_url:this.router.navigate(['/booking-confirm-detail'])
    };
    // ;
    console.log(options);

    // ;
    // this.loaderShow=true
    if (this.countryCode == '+91'|| this.countryCode == '+44') {
      this.countryCode = this.countryCode.split('+')[1];
      console.log('this.countryCode', this.countryCode);
    } else {
      this.countryCode = this.countryCode;
    }
    console.log('', this.HCPTypeId);
    console.log(this.feeAmount.toString());

    let paymentSave = {
      PatientId: this.PatientId,
      amount: Math.ceil(this.feeAmount).toString(), //this.feeAmount.toString(),
      rate_difficulties: this.rate_difficulties,
      Timezone: this.timeZone,
      coupon_applied: this.coupon_applied,
      PayUDetails: {
        razorpay_order_id: '',
        razorpay_signature: '',
        razorpay_payment_id: ' ',
      },
      reason: '',
      Sugar: '/',
      HCPId: this.hcpId,
      Temperature: '',
      otherSymptoms: '',
      TransactionId: 0,
      preferred_from_time: this.BlockStartTime,
      Pulse: '',
      RequestedBy: 'Patient',
      beforePrice: Math.ceil(this.feeAmount).toString(), //this.feeAmount.toString(),
      HCPTypeId: this.HCPTypeId,
      SessionId: this.sessionId,
      duration_of_difficulties:
        this.duration_of_difficulties === 'Others'
          ? this.otherDuration
          : this.duration_of_difficulties,
    
      // duration_of_difficulties: this.duration_of_difficulties,
      describeDifficulties: this.describeDifficulties,
      Bp: '/',
      countryCode: this.countryCode,
      first_appointment_with_doctor: this.isFirstAppointment,
      preferred_to_time: this.BlockEndTime,
      access_code_applied:this.accessCodeText
    };
    console.log('paymentSave', paymentSave);
    if (this.feeAmount.toString() == '0') {
      let savePayment = {
        SessionId: this.sessionId,
        HCPId: this.hcpId,
        beforePrice: Math.ceil(this.feeAmount).toString(), // this.feeAmount.toString(),
        amount: Math.ceil(this.feeAmount).toString(), //  this.feeAmount.toString(),
        Bp: '/',
        Sugar: '/',
        Pulse: '',
        Temperature: '',
        otherSymptoms: '',
         rate_difficulties:this.rate_difficulties,
           duration_of_difficulties:
        this.duration_of_difficulties === 'Others'
          ? this.otherDuration
          : this.duration_of_difficulties,
        //  duration_of_difficulties: this.duration_of_difficulties,
        describeDifficulties: this.describeDifficulties,
        first_appointment_with_doctor: this.isFirstAppointment,
        coupon_applied: '',
        // "preferred_from_time": 1753257600,
        /* "preferred_to_time": 1753257900, */
        preferred_to_time: this.BlockEndTime,
        preferred_from_time: this.BlockStartTime,
        reason: '',
        RequestedBy: 'Patient',
        // "Timezone": "Asia/Kolkata",
        Timezone: this.timeZone,
        package_purchase_date: this.package_purchase_date,
        PatientId: this.PatientId,
        countryCode: this.countryCode,
        access_code_applied:this.accessCodeText
      };
      console.log('step1');
      // ;
      this.http
        .post(
          environment.baseUrl + '/mobileappointment/SaveAppointment',
          savePayment
        )
        .subscribe(
          (res: any) => {
            // console.log(res)
            // let divId = document.getElementById('id13')
            // divId?.classList.add('add');
            // console.log(divId);
            console.log(res);
                 
            if (res.success == 3) {
              alert(res.message);
            } else {
              let loderId = document.getElementById('loaderId');
              console.log('hhhhh', loderId);
              loderId?.classList.remove('add');
              let t1 = document.getElementById('test1234');
              console.log(t1);
              t1?.classList.add('test1234');
              console.log(t1);
              // alert('Ok..')
            }
          },
          (error: any) => {
            console.log(error);
          }
        );
    } else {
      // ;
      console.log(
        this.selectedPackageTypeSssion,
        this.percentage_off,
        this.package_code
      );
      if (this.selectedPackageTypeSssion) {
        // ;
        paymentSave.coupon_applied =
          this.package_code + ',' + this.percentage_off;
        let todayDate = new Date();
        let todayDateInSec = Date.parse(todayDate.toString()) / 1000;
        this.package_purchase_date = todayDateInSec;
        Object.assign(paymentSave, {
          package_code: this.package_code,
          no_of_calls: this.no_of_calls,
          package_purchase_date: this.package_purchase_date * 1000,
        });
      }
      console.log(paymentSave);
      // ;
    
      // ;
      let data = {
        // amount: this.convertTodata.actualPrice,
        amount: Math.ceil(this.feeAmount),
        // currency: 'INR',
         currency: actualCurrency,
        name:
          this.userDetailsData.FirstName + '' + this.userDetailsData.LastName,
        email: this.userDetailsData.email,
        phone: this.userDetailsData.phone,
      };
      console.log('.................', data);
      // ;
      console.log(paymentSave);
      options.handler = (response: any, error: any) => {
        let loderId = document.getElementById('loaderId');
        console.log('hhhhh', loderId);
        loderId?.classList.add('add');
        let divId2 = document.getElementById('id2');
        divId2?.classList.remove('add');
        let divId = document.getElementById('id13');
        divId?.classList.add('add');
        console.log(divId);
        // let divId2 = document.getElementById('id2');
        // divId2?.classList.remove('add');
        this.displayStyle2 = 'none';
        // ;
        // console.log('divId2' + divId2);
        options.response = response;
        paymentSave.PayUDetails.razorpay_order_id =
          options.response.razorpay_order_id;
        (paymentSave.PayUDetails.razorpay_payment_id =
          options.response.razorpay_payment_id),
          //  (paymentSave.status = 'Capture');
          console.log('step1');
        // ;
        // this.loaderShow = true;
        console.log(paymentSave);
         posthog.capture('Payment Status', {
                    status: "Successfull",
                    page: 'dashboard',
                    
                  });
        this.http
          .post(
            environment.baseUrl + '/mobileappointment/SaveAppointment',
            paymentSave
          )
          .subscribe(
            (res: any) => {
              // console.log(res)
              // let divId = document.getElementById('id13')
              // divId?.classList.add('add');
              // console.log(divId);
              if (res.success == 3) {
  
                alert(res.message);
              } else {
                let loderId = document.getElementById('loaderId');
                console.log('hhhhh', loderId);
                loderId?.classList.remove('add');
                let t1 = document.getElementById('test1234');
                console.log(t1);
                t1?.classList.add('test1234');
                console.log(t1);
                // alert('Ok..')
              }
            },
            (error: any) => {
              console.log(error);
            }
          );
        // call your backend api to verify payment signature & capture transaction
      };
      options.modal.ondismiss = () => {
        // this.backtohome();
        console.log('Transaction cancelled.');
        let divId2 = document.getElementById('id2');
        divId2?.classList.remove('add');
        this.displayStyle2 = 'none';
        let loderId = document.getElementById('loaderId');
        console.log('hhhhh', loderId);
        loderId?.classList.remove('add');
        let winDiv = this.document.getElementById('bodyId');
        winDiv?.classList.remove('b');
          posthog.capture('Payment Status', {
  status: "failure",
  page: 'dashboard',
  
});
      };
      this.http
        .post(
          environment.baseUrl + '/mobilewebController/webPaymentPlan',
          data
          //  'https://mychatadoc.com/mobilewebController/webPaymentPlan', data
        )
        .subscribe((res: any) => {
          console.log(res);
          // ;
          console.log('step3');
          options.order_id = res.data.id;
          options.amount = res.data.amount;
          console.log(options);
          // ;
          const rzp1 = new Razorpay(options);
          rzp1.open();
        });
    }
  }
  enableDisableRule() {
    this.toggle = !this.toggle;
    this.status = this.toggle ? 'Enable' : 'Disable';
  }
  backtohomeOpenModel(pagesection: any, event: any) {
      const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    let divId = document.getElementById('id13');
    divId?.classList.add('add');
    let loderId = document.getElementById('loaderId');
    console.log('hhhhh', loderId);
    loderId?.classList.remove('add');
    this.displayStyle3 = 'none';
    let winDiv = this.document.getElementById('bodyId');
    winDiv?.classList.remove('b');
    this.commonmodel.subject.next('modal-xl');
    this.route.navigate(['my-appointments']);
  }
  backtohome() {
    this.displayStyle3 = 'block';
    let divId = document.getElementById('id3');
    divId?.classList.add('add');
  }
  clicked: string = '';
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    console.log(event.target.className);
    // alert(event.target.className)
    if (
      event.target.className == 'modal' ||
      event.target.className == 'modal add'
    ) {
      // ;
      this.loaderShow = false;
      this.displayStyle1 = 'none';
      this.cancelAppointment();
      this.availabeTabTypeShow = '';
      this.appliedCoupon = null;
      this.couponList = '';
      let winDiv = this.document.getElementById('bodyId');
      winDiv?.classList.add('b');
      winDiv?.classList.add('d');

      this.booktbnEnable = true;
      this.selectedPackageTypeSssion = '';
      this.couponCodeText = '';
      this.sessionBookTab = 1;
      this.couponCodeDesiabled = false;
      this.commonmodel.subject.next('modal-xl');
      this.step_1 = true;
      this.step_2 = false;
      this.selectPakageSession = false;
      this.selectSingleSession = true;
      this.package_code = '';
      this.initailizeRatingIcon();
    }
  }
  initailizeRatingIcon() {
   
    this.dificultyRate = [
      {
        id: '1',
        src: 'img/dr_img/emoji1.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji1.png',
      },
      {
        id: '2',
        src: 'img/dr_img/emoji2.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji2.png',
      },
      {
        id: '3',
        src: 'img/dr_img/emoji3.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji3.png',
      },
      {
        id: '4',
        src: 'img/dr_img/emoji4.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji4.png',
      },
      {
        id: '5',
        src: 'img/dr_img/emoji5.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji5.png',
      },
      {
        id: '6',
        src: 'img/dr_img/emoji6.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji6.png',
      },
      {
        id: '7',
        src: 'img/dr_img/emoji7.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji7.png',
      },
      {
        id: '8',
        src: 'img/dr_img/emoji8.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji8.png',
      },
      {
        id: '9',
        src: 'img/dr_img/emoji9.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji9.png',
      },
      {
        id: '10',
        src: 'img/dr_img/emoji10.png',
        acive: false,
        activesrc: 'img/dr_img/colouremoji10.png',
      },
    ];
  }
  gitRattingValue(a: any, ctlr: any) {
     posthog.capture('Button Clicked', {
  butto_name: "Rating of your difficulties",
  page: 'dashboard',
  
});
    console.log(a.src);
    this.initailizeRatingIcon();
    // ;
    //ctlr.src = a.activesrc;
    this.dificultyRate[a.id - 1].src = a.activesrc;
    console.log(this.dificultyRate);
    this.sessionTypeShow = a.id;
    this.rate_difficulties = a.id;
    console.log(this.sessionTypeShow);
  }
  testModel() {
    // alert("click")
    let t1 = document.getElementById('test1234');
    console.log(t1);
    t1?.classList.add('test1234');
    console.log(t1);
    // this.displayStyle4='block'
  }
  openPopup() {
    this.displayStyle = 'block';
  }
  closePopup() {
    this.displayStyle = 'none';
  }
  saverequestquerydata(RqestQueryFormData: any) {
    this.submitted = true;
    if (this.RqestQueryFormData.invalid) {
      return;
    }
    this.loaderShow = true;
    this.http
      .post(
        environment.baseUrl + '/mobilewebController/hcpEnquiry ',
        RqestQueryFormData.value
      )

      .subscribe(
        (res) => {
          console.log(res);

          this.loaderShow = false;
          this.thankYouModelOpen();

          this.RqestQueryFormData.reset();
          this.submitted = false;
          // this.inquarybtn = false;
          this.closePopup();
        },
        (error) => {
          console.log(error);
        }
      );
  }
  thankYouModelOpen() {
    this.displayStyle1 = 'block';
  }

  thanYouModelOpenForPayment() {
    
    this.displayStyle8 = 'block';
  }

  thankYouModelClose1(pagesection: any, event: any) {
      const buttonText =
    (event.target as HTMLElement)?.innerText?.trim() || 'unknown';

  posthog.capture('Button Clicked', {
  button_name: buttonText,
  page: 'dashboard',
  section: pagesection
});
    this.displayStyle8 = 'none';
  }

  invokeStripe() {
    if (!window.document.getElementById('stripe-script')) {
      const script = window.document.createElement('script');
      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      // 
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          // key: 'pk_test_51K3xFVJZJR5ggjW3zakXGCgnlRNcUyqWPKmL64RKdIf3aR7R12LrEWPR09B0UMhkyrqBoktGvIi6edCpGeGMaRgi00P5FxxRNo',
          // key: 'pk_test_51O5mzjSCrQ4ij6hqTtvXfa8XhzHNVTTB4lfPnleBlzKYNlIsfuCaP8FWoI81YGKpyNWFZrfM8S8dj230s0NZkRqQ005jZc9OEK',
          key: environment.stripeKey,
          locale: 'auto',
          token: (stripeToken: any) => {
            console.log('hhhhhhhhhhhhhhh', stripeToken.card.id);
            alert(stripeToken);
          },
        });
      };
      window.document.body.appendChild(script);
    }
  }

  initializePayment(amount: number) {
    /* amount=100 */
    const paymentHandler = (<any>window).StripeCheckout.configure({
      /* key:'pk_test_51K3jzwLplTQfgWbJRILDEE2QIul2pzVli5qssejXWs6W0mZBk6B1DBXItX8296TBN54h8Yblxo9R0hZcH6d2UJE000F8h9bI9m', */
      // key:'pk_test_51K3jzwLplTQfgWbJRILDEE2QIul2pzVli5qssejXWs6W0mZBk6B1DBXItX8296TBN54h8Yblxo9R0hZcH6d2UJE000F8h9bI9m',

      key: environment.stripeKey,

      locale: 'auto',
      token: (stripeToken: any) => {
        let data = {
          stripeToken: stripeToken,
        };
        console.log('kkkk', data.stripeToken.id);
        console.log('kkkk', data.stripeToken.email);
        console.log({ stripeToken });

        let StripePaymentDetail = {
          amount: Math.ceil(amount * 100),
          currency: 'USD',
          city: 'cit',
          country: 'cjjj',
          address1: 'saas',
          address2: 'sdasd',
          postal_code: 'das',
          state: '',
          name: 'mamm',
        };

        this.http
          .post(
            environment.baseUrl +
              '/mobilebraintreepaymentgateway/payment_intent',
            StripePaymentDetail
          )
          .subscribe((res: any) => {
            console.log(res);
          });

        // 
      },
    });
    console.log('paymentHandler', paymentHandler);

    paymentHandler.open({
      email: 'manoj@gmail.com',
      name: localStorage.getItem('userId'),
      description: 'Buying mat',
      amount: amount * 100,
    });
  }

  roundUp(value: number): number {
  return Math.ceil(value);
}
  async payStripeInt() {
    let divId2 = document.getElementById('id2');
    divId2?.classList.remove('add');
    this.displayStyle10 = 'block';
     const { loadStripe } = await import('@stripe/stripe-js');
    this.stripe = await loadStripe(
      environment.stripeKey
    );

    /*  this.stripe =await loadStripe('pk_live_51K3jzwLplTQfgWbJV05XHfZpCY2jvfoumzvWHuZRDG8AGOv54gPSgyGAtPg2FxuKGVNgqJbcOlb4fMmzdDfF9EGk005Z06O0n5'); */

    // Create an instance of the card Element
    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4',
        },
        backgroundColor: '#f5f5f5',
        padding: '10px 12px',
        border: '1px solid #ced4da',
        borderRadius: '4px',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
        borderColor: '#fa755a',
        boxShadow: '0 0 5px rgba(255, 0, 0, 0.5)',
      },
    };

    const elements = this.stripe.elements();
    this.card = elements.create('card', { style: style });
    this.card.mount('#card-element');
    this.addressElement = elements?.create('address', {
      mode: 'shipping', // or 'billing', depending on use case
      style: style,
    });

    // Mount the address element to a DOM element with the ID 'address-element'
    this.addressElement?.mount('#address-element');
  }

  async handlePayment() {
    // Confirm the payment with the client secret
    console.log('feeAmount', this.feeAmount);
     if(this.feeAmount<=0){
        this.bookAppointmentUsedByAccesscodewithzeroPayment()
     }
     else{
      this.usWithPayment();
     }
   
  }


  bookAppointmentUsedByAccesscodewithzeroPayment() {
    let obj = {
                reason: '',
                HCPId: this.hcpId,
                otherSymptoms: '',
                HcpLastName: this.hcpLastname,
                stripeIntentId: '',
                preferred_to_time: this.BlockEndTime,
                RequestedBy: 'Patient',
                preferred_from_time: this.BlockStartTime,
                PatientId: this.PatientId,
                first_appointment_with_doctor: this.isFirstAppointment,
                beforePrice: Math.ceil(this.feeAmount).toString(), //this.feeAmount.toString(),
                stripePaymentId: '',
                amount: Math.ceil(this.feeAmount).toString(), //this.feeAmount.toString(),
                coupon_applied: '',
                HcpFirstName: this.hcpFirstName,
                describeDifficulties: this.describeDifficulties,
                Timezone: 'Asia/Kolkata',
                SessionId: this.sessionId,
                // duration_of_difficulties: this.duration_of_difficulties,
                  duration_of_difficulties:
        this.duration_of_difficulties === 'Others'
          ? this.otherDuration
          : this.duration_of_difficulties,
                rate_difficulties: this.rate_difficulties,
                access_code_applied:this.accessCodeText
              };

              this.dashboard.UsaCustomerbookAppointment(obj).subscribe(
                (res: any) => {
                  // ;
                  console.log(res);
                  this.displayStyle10 = 'none';
                  let el = this.document.getElementById('test1234');
                  el?.classList.add('add');

                  // this.route.navigate(['/insights'])
                },
                (error) => {
                  console.log(error);
                }
              );
  }
  
  usWithPayment() {
      let loderId = document.getElementById('loaderId');
        console.log('hhhhh', loderId);
        loderId?.classList.add('add');
     const address = this.addressElement?.getValue().then((res: any) => {
      let test = res.value;
      console.log(test);
      if (test.name == '') {
        alert('Please fill all requesred field');
        loderId?.classList.remove('add');
        return;
      }
      if (test.address.line1 == '') {
        alert('Please fill all requesred field');
        loderId?.classList.remove('add');
        return;
      }
      if (test.address.city == '') {
        alert('Please fill all requesred field');
        loderId?.classList.remove('add');
        return;
      }
      if (test.address.state == '') {
        alert('Please fill all requesred field');
        loderId?.classList.remove('add');
        return;
      }
      if (test.address.postal_code == '') {
        alert('Please fill all requesred field');
        loderId?.classList.remove('add');
        return;
      }

      this.name123 = test.name;
      this.state = test.address.line1;
      this.line2 = test.address.line2;
      this.city = test.address.city;
      
      let obj = {
        amount: Math.ceil(this.feeAmount * 100),
        currency: 'usd',
        city: test.address.city,
        country: test.address.country,
        address1: test.address.line1,
        address2: test.address.line2,
        postal_code: test.address.postal_code,
        state: test.address.state,
        name: test.name,
      };
      console.log(obj);

      this.http
        .post<{ paymentIntent: string; id: string }>(
          environment.baseUrl + '/mobilebraintreepaymentgateway/payment_intent',
          obj
        )
        .subscribe(async (res: any) => {
          let stripePaymentId = res.id;
          this.clientSecret = res.paymentIntent;
          console.log(this.clientSecret);
          if (this.clientSecret) {
            const { paymentIntent, error } =
              await this.stripe.confirmCardPayment(this.clientSecret, {
                payment_method: {
                  card: this.card,
                },
              });
            console.log(paymentIntent);
            if (error) {
              console.error('Payment failed:', error);
              loderId?.classList.remove('add');
            } else if (paymentIntent) {
              console.log('Payment successful!');
              loderId?.classList.remove('add');

              let obj = {
                reason: '',
                HCPId: this.hcpId,
                otherSymptoms: '',
                HcpLastName: this.hcpLastname,
                stripeIntentId: stripePaymentId,
                preferred_to_time: this.BlockEndTime,
                RequestedBy: 'Patient',
                preferred_from_time: this.BlockStartTime,
                PatientId: this.PatientId,
                first_appointment_with_doctor: this.isFirstAppointment,
                beforePrice: Math.ceil(this.feeAmount).toString(), //this.feeAmount.toString(),
                stripePaymentId: stripePaymentId,
                amount: Math.ceil(this.feeAmount).toString(), //this.feeAmount.toString(),
                coupon_applied: '',
                HcpFirstName: this.hcpFirstName,
                describeDifficulties: this.describeDifficulties,
                Timezone: 'Asia/Kolkata',
                SessionId: this.sessionId,
                  duration_of_difficulties:
        this.duration_of_difficulties === 'Others'
          ? this.otherDuration
          : this.duration_of_difficulties,
                // duration_of_difficulties: this.duration_of_difficulties,
                rate_difficulties: this.rate_difficulties,
                access_code_applied:this.accessCodeText
              };

              this.dashboard.UsaCustomerbookAppointment(obj).subscribe(
                (res: any) => {
                  // ;
                  console.log(res);
                  this.displayStyle10 = 'none';
                  let el = this.document.getElementById('test1234');
                  el?.classList.add('add');

                  // this.route.navigate(['/insights'])
                },
                (error) => {
                  console.log(error);
                }
              );
            }
          }
        });
    }); // Get the address element data

    if (address) {
      // Process the address or send it to your server
      console.log('Address Data:', address);
    }
  }

  closemodel() {
    this.displayStyle10 = 'none';
    let winDiv = this.document.getElementById('bodyId');
    winDiv?.classList.remove('b');
  }
  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  accessCodedata: any;
  accessCodeText: any;
  ngOnChanges(changes: SimpleChanges): void {
    console.log('gsfdgfa', changes);
    let getAccessCodeDetails = sessionStorage.getItem('accessCodeData');
console.log('Access Code from sessionStorage:', getAccessCodeDetails);

      if (getAccessCodeDetails) {
        try {
          const accessCodedataJson = JSON.parse(getAccessCodeDetails || '{}');
          console.log('Parsed Access Code Data:', accessCodedataJson);
          this.accessCodedata = accessCodedataJson?.discount ?? null;
          this.accessCodeText = accessCodedataJson?.displayName ?? null;

        } catch (e) {
          console.error("JSON parse error:", e);
          this.accessCodedata = null;
          this.accessCodeText = null;
        }
      } else {
        // When null or empty
        this.accessCodedata = null;
        this.accessCodeText = null;
        console.log("No access code found in sessionStorage");
      }

    
    // this.http
    //   .post(environment.baseUrl + '/mobileappointment/getAccessCodeDetails', {
    //     patientId: this.PatientId,
    //   })
    //   .subscribe((data: any) => {
    //     console.log('Access Code Details:', data.data);
    //     this.accessCodedata = data.data[0].discount;
    //     this.accessCodeText = data.data[0].displayName;
    //     console.log('Access Code Text:', this.accessCodeText);
    //   });
    this.bookSession(this.inputFromParent, this.inputFromParent1);
  }
  trackDifficultyDuration(value: string) {
  posthog.capture('dropdown_option_selected', {
    duration: value,
    page: 'dashboard',
    field_name: 'duration_of_difficulties',
  });
  }
}
